import React from "react";
import Fit from "../Certificates/Fit";
import "../Certificates/HeldUp.scss";

const HeaderReportPrint = () => {
  return <Fit />;
};
export default HeaderReportPrint;
